import React, { useState } from 'react'
import type { GestureResponderEvent } from 'react-native'

import { Icon } from '~/components/icon'
import { Chip } from '../..'

import type { IMultiFilterProps, ILabelProps, IBadgeProps } from '../../types'

import * as S from './index.styles'

export function MultiFilter(props: IMultiFilterProps) {
  const {
    checked = false,
    selected = false,
    size = 'md',
    onPressIn,
    onPressOut,
    children,
    disabled = false,
    readOnly = false,
    prefixIcon,
  } = props

  const [isPressed, setIsPressed] = useState(false)

  const iconColor = () => {
    if (disabled) return 'colorTextNeutralDisabled'
    if (isPressed) return 'colorTextNeutralDefault'
    if (checked) return 'colorTextNeutralDefault'
    if (readOnly) return 'colorTextNeutralReadonly'
    return 'colorTextNeutralDefault'
  }

  const iconSize = () => {
    if (size === 'md' && selected) return 'extra-small'
    if (size === 'md' && !selected) return 'tiny'
    return 'small'
  }
  const defaultProps = {
    checked,
    size,
    type: 'singleFilter',
    disabled: disabled,
  }

  const childProps = {
    disabled: disabled,
    readOnly: readOnly,
    checked: checked,
    selected: selected,
  }

  const { labelComponent, badgeComponent } = React.Children.toArray(
    children
  ).reduce(
    (acc, child) => {
      if (!React.isValidElement(child)) return acc

      if (child.type === Chip.Label) {
        acc.labelComponent = React.cloneElement(
          child,
          childProps as unknown as ILabelProps
        )
      }

      if (child.type === Chip.Badge) {
        acc.badgeComponent = React.cloneElement(
          child,
          childProps as unknown as IBadgeProps
        )
      }

      return acc
    },
    {
      labelComponent: null,
      badgeComponent: null,
    } as {
      labelComponent: React.ReactNode
      badgeComponent: React.ReactNode
    }
  )

  function handlePressIn(event: GestureResponderEvent) {
    setIsPressed(true)
    onPressIn?.(event)
  }

  function handlePressOut(event: GestureResponderEvent) {
    setIsPressed(false)
    onPressOut?.(event)
  }

  return (
    <S.Root
      {...props}
      {...defaultProps}
      {...{ isPressed }}
      onPressIn={handlePressIn}
      onPressOut={handlePressOut}
    >
      <Icon
        size={iconSize()}
        symbol={prefixIcon ?? 'rdicon-options-filter'}
        color={iconColor()}
      />

      <S.Content>{labelComponent}</S.Content>

      {badgeComponent}
    </S.Root>
  )
}
